import React, {useState} from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {translation} from "../../../../I18n/i18n";
import SpellChecker from "../../../UI/SpellChecker/SpellChecker";
import ConsultCard from "../../../UI/SkillCard/ConsultCard";
import {cloneDeep} from "lodash";
import EditCard from "../../../UI/SkillCard/EditCard";
import classes from "../LinguisticSkills/LinguisticSkill/LinguisticSkill.module.css";
import {Col, Row} from "react-bootstrap";
import Icon from "../../../UI/Icon/Icon";
import EducationTrainingContent from "./EducationTrainingContent";
import EducationAndTrainingEntity from "../../../../Entities/EducationAndTrainingEntity";
import {EducationAndTrainingEnum} from "../../../../Enumerations/EducationAndTrainingEnum";

const EducationAndTraining = (props) => {
    const [educations, setEducations] = useState(props.element.Education.Description._text);
    const [trainings, setTrainings] = useState(props.element.Training.Description._text);
    const [certification, setCertification] = useState(props.element.Certification.Description._text);

    const removeCurrentElement = (element,sectionElement) => {
        sectionElement.List.map((e, i) => {
            if (e === element) {
                sectionElement.List.splice(i, 1);
                setRemovedElements(removedElements.concat(element))
            }
            return sectionElement.List
        })
    }

    function editCurrentElement(e) {
        setEditElement(e);
    }

    const [expandedEducationSection, setExpandedEducationSection] = useState(false);
    const [expandedTrainingSection, setExpandedTrainingSection] = useState(false);
    const [expandedCertificationSection, setExpandedCertificationSection] = useState(false);
    const [editElement, setEditElement] = useState();
    const [educationSection, setPreviousEducationSection] = useState([]);
    const [trainingSection, setPreviousTrainingSection] = useState([]);
    const [certificationSection, setPreviousCertificationSection] = useState([]);
    const [removedElements, setRemovedElements] = useState([]);
    const addHandler = (sectionName,isExpanded) => {
        const newEmptySection = cloneDeep(EducationAndTrainingEntity);
        getPreviousSectionSetter(sectionName,newEmptySection);
        getExpandedSectionSetter(sectionName,isExpanded);
    };
    function getPreviousSectionSetter(sectionName,newEmptySection) {
        switch (sectionName) {
            case EducationAndTrainingEnum.Education:
                 return setPreviousEducationSection(educationSection.concat(newEmptySection));
            case EducationAndTrainingEnum.Training:
                return setPreviousTrainingSection(trainingSection.concat(newEmptySection));
            case EducationAndTrainingEnum.Certification:
                return setPreviousCertificationSection(certificationSection.concat(newEmptySection));
        }
    }
    const getExpandedSectionSetter = (sectionName,isExpanded) => {
        switch (sectionName) {
            case EducationAndTrainingEnum.Education:
                return setExpandedEducationSection(isExpanded);
            case EducationAndTrainingEnum.Training:
                return setExpandedTrainingSection(isExpanded);
            case EducationAndTrainingEnum.Certification:
                return setExpandedCertificationSection(isExpanded);
        }
    };
    function addElementsToStateBySection(element,sectionName){
        switch (sectionName) {
            case EducationAndTrainingEnum.Education:
                return element.List.push(educationSection[educationSection.length - 1])
            case EducationAndTrainingEnum.Training:
                return element.List.push(trainingSection[trainingSection.length - 1])
            case EducationAndTrainingEnum.Certification:
                return element.List.push(certificationSection[certificationSection.length - 1])
        }
    }
    const cancelAddingHandler = (sectionName,isExpanded) => {
        getExpandedSectionSetter(sectionName,isExpanded)
    };
    const cancelEditHandler = () => {
        setEditElement(null)
    };
    const submitHandler = (element,sectionName,isExpanded) => {
        if (element.List !== undefined) {
            addElementsToStateBySection(element,sectionName)
            getExpandedSectionSetter(sectionName,isExpanded)
        } else {
            let newEducList = []
            element["List"] = newEducList
            addElementsToStateBySection(element,sectionName)
            getExpandedSectionSetter(sectionName,isExpanded)
        }
    };
    const submitEditHandler = (element,sectionElement) => {
        sectionElement.List.map((e, i) => {
            if (e === editElement) {
                sectionElement.List[i] = element;
            }
            return sectionElement.List
        })
        setEditElement(null)
    };

    function sectionElementTitle(element, lang) {
        if (element?.location?._text!== undefined && element?.location?._text!=="") {
            return (translation(lang, element.title._text)
                + ", " + translation(lang, element.year._text) + ", "
                + translation(lang, element.location._text))
        } else {
            return (translation(lang, element.title._text) + ", "
                + translation(lang, element.year._text))
        }
    }
    let getConsultEditView = (i, e,sectionElement) => {
        let element = cloneDeep(e)
        let title=(element && element.year && element.title)? sectionElementTitle(element, props.lang): ""
        if (e !== editElement)
            return (
                <ConsultCard
                    key={i}
                    index={i}
                    lang={props.lang}
                    language={e}
                    hasWriteAccess={props.hasWriteAccess}
                    removeElement={() => removeCurrentElement(e,sectionElement)}
                    editElement={() => editCurrentElement(e)}
                    title={title}
                />
            )
        else
            return (
                <EditCard
                    title={translation(props.lang, "Edit") + " : " + title}
                    lang={props.lang}
                    content={<EducationTrainingContent
                        dict={props.dict}
                        notify={props.notify}
                        addToDictionary={props.addToDictionary}
                        section={element}
                        lang={props.lang}
                        buttonTitle={translation(props.lang, "Confirm")}
                        submit={() => submitEditHandler(element,sectionElement)}
                        cancel={() => cancelEditHandler()}
                    />}

                />
            )
    }
    return (
        <div>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{translation(props.lang, "Education")}</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordion}>
                    {props.element.Education.Description._text !== undefined ? (
                        <div style={{marginBottom: "10px"}}>
                            <SpellChecker freeTextBox
                                          dict={props.dict}
                                          notify={props.notify}
                                          addToDictionary={props.addToDictionary}
                                          lang={props.lang}
                                          onChange={v => {
                                              setEducations(v)
                                              props.element.Education.Description._text = v
                                          }}
                                          value={educations}/>
                        </div>
                    ) : null
                    }
                    {props.element.Education.List !== undefined && props.element.Education.List.length !== 0 ? (
                        props.element?.Education?.List.map((e, i) => {
                                return (
                                    <div key={i} className={classes.linguisticSkill}>
                                        {getConsultEditView(i, e,props.element.Education)}
                                    </div>
                                )
                            }
                        )) : null}
                    {expandedEducationSection ? (
                        <EditCard
                            lang={props.lang}
                            title={translation(props.lang, "New Education")}
                            content={<EducationTrainingContent
                                dict={props.dict}
                                notify={props.notify}
                                addToDictionary={props.addToDictionary}
                                section={educationSection[educationSection.length - 1]}
                                lang={props.lang}
                                buttonTitle="Add"
                                submit={()=>submitHandler(props.element.Education,EducationAndTrainingEnum.Education,false)}
                                cancel={() => cancelAddingHandler(EducationAndTrainingEnum.Education,false)}
                            />}
                        />
                    ) : props.hasWriteAccess && <Row className={classes.SpacingTop}>
                        <Col sm="11"/>
                        <Col sm="1" style={{paddingTop: "5px"}}>
                            <Icon
                                classIcon="fas fa-plus-circle"
                                color="#464775"
                                size="30"
                                label="Add new Linguistic Skill "
                                action={()=>addHandler(EducationAndTrainingEnum.Education,true)}
                            />
                        </Col>
                    </Row>}
                </AccordionDetails>
            </Accordion>
              <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>{translation(props.lang, "Training")}</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordion}>
                    {props.element.Training.Description._text !== undefined ? (
                        <div style={{marginBottom: "10px"}}>
                            <SpellChecker freeTextBox
                                          dict={props.dict}
                                          notify={props.notify}
                                          addToDictionary={props.addToDictionary}
                                          lang={props.lang}
                                          onChange={v => {
                                              setTrainings(v)
                                              props.element.Training.Description._text = v
                                          }}
                                          value={trainings}/>
                        </div>
                    ) : null
                    }
                    {props.element.Training.List !== undefined && props.element.Training.List.length !== 0 ? (
                        props.element?.Training?.List.map((e, i) => {
                                return (
                                    <div key={i} className={classes.linguisticSkill}>
                                        {getConsultEditView(i, e,props.element.Training)}
                                    </div>
                                )
                            }
                        )) : null}
                    {expandedTrainingSection ? (
                        <EditCard
                            lang={props.lang}
                            title={translation(props.lang, "New Training")}
                            content={<EducationTrainingContent
                                dict={props.dict}
                                notify={props.notify}
                                addToDictionary={props.addToDictionary}
                                section={trainingSection[trainingSection.length - 1]}
                                lang={props.lang}
                                buttonTitle="Add"
                                submit={()=>submitHandler(props.element.Training,EducationAndTrainingEnum.Training,false)}
                                cancel={() => cancelAddingHandler(EducationAndTrainingEnum.Training,false)}
                            />}
                        />
                    ) : props.hasWriteAccess && <Row className={classes.SpacingTop}>
                        <Col sm="11"/>
                        <Col sm="1" style={{paddingTop: "5px"}}>
                            <Icon
                                classIcon="fas fa-plus-circle"
                                color="#464775"
                                size="30"
                                label="Add new Linguistic Skill "
                                action={()=>addHandler(EducationAndTrainingEnum.Training,true)}
                            />
                        </Col>
                    </Row>}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                >
                    <Typography>{translation(props.lang, "Certifications")}</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordion}>
                    {props.element.Certification.Description._text !== undefined ? (
                        <div style={{marginBottom: "10px"}}>
                            <SpellChecker freeTextBox
                                          dict={props.dict}
                                          notify={props.notify}
                                          addToDictionary={props.addToDictionary}
                                          lang={props.lang}
                                          onChange={v => {
                                              setCertification(v)
                                              props.element.Certification.Description._text = v
                                          }}
                                          value={certification}/>
                        </div>
                    ) : null
                    }
                    {props.element.Certification.List !== undefined && props.element.Certification.List.length !== 0 ? (
                        props.element?.Certification?.List.map((e, i) => {
                                return (
                                    <div key={i} className={classes.linguisticSkill}>
                                        {getConsultEditView(i, e,props.element.Certification)}
                                    </div>
                                )
                            }
                        )) : null}
                    {expandedCertificationSection ? (
                        <EditCard
                            lang={props.lang}
                            title={translation(props.lang, "New Certification")}
                            content={<EducationTrainingContent
                                dict={props.dict}
                                notify={props.notify}
                                addToDictionary={props.addToDictionary}
                                section={certificationSection[certificationSection.length - 1]}
                                lang={props.lang}
                                buttonTitle="Add"
                                submit={()=>submitHandler(props.element.Certification,EducationAndTrainingEnum.Certification,false)}
                                cancel={() => cancelAddingHandler(EducationAndTrainingEnum.Certification,false)}
                            />}
                        />
                    ) : props.hasWriteAccess && <Row className={classes.SpacingTop}>
                        <Col sm="11"/>
                        <Col sm="1" style={{paddingTop: "5px"}}>
                            <Icon
                                classIcon="fas fa-plus-circle"
                                color="#464775"
                                size="30"
                                label="Add new Linguistic Skill "
                                action={()=>addHandler(EducationAndTrainingEnum.Certification,true)}
                            />
                        </Col>
                    </Row>}
                </AccordionDetails>

            </Accordion>
        </div>
    )
};

export default EducationAndTraining;
